import templateUrl from './template.html';

export const janglErrorsComponent = {
    templateUrl: templateUrl,
    bindings: {
        // pass the form errors
        errors: '=',
    }
};

export default janglErrorsComponent;


// WEBPACK FOOTER //
// ./app/jangl/jangl-errors/component.js